import { render, staticRenderFns } from "./addProductGroupModal.vue?vue&type=template&id=4d80cc57&"
import script from "./addProductGroupModal.vue?vue&type=script&lang=js&"
export * from "./addProductGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports